<ng-container>
    <div class="UNFAPP-asmnt-testbx" [ngClass]="info_box_class" style="cursor: pointer;">
        <div class="button-overlay" (click)="gotoList($event)"></div>
        <img src="assets/img/new-right-tag.svg" class="UNFAPP-asmnt-new-tag" *ngIf="infobox.shortname == 'CQT'" />
        <div class="UNFAPP-tests-hwrp">
            <!-- <img *ngIf="infobox?.shortname != 'SCORE' && infobox?.shortname != 'AICTS' && infobox?.shortname != 'RRRDT' && infobox?.shortname != 'RRRTS'" src="assets/img/tests-icons/{{infobox?.shortname | uppercase}}.svg" alt="" class="UNFAPP-tsts-imgh"/>    -->
            <h2 class="h2-testbx-hdng UFAPP-Tsts-textalgn">{{infobox.heading}}</h2>
        </div>
        <div class="UNFAPP-asmnt-bx-actn">
            <div class="asmnt-cunt">
                <div class="UNFAPP-c-tooltip"><img src="assets/img/tooltip-info-icon.svg" class="info-tooltipicon" />
                <div class="UNFAPP-c-tooltip-box">
                    <h2 class="h2-tooltiip-heading">About {{infobox.heading}}</h2>
                    <p class="para">{{infobox.description}}</p>
                </div>
                </div>
                <span href={{infobox.link.route}} (click)="gotoList($event)" style="cursor: pointer;" *ngIf="infobox.paper.completedtests==0 && infobox?.examtype !== '53355d15-4a4a-4df8-a881-688c43f0c65e'">
                    {{infobox.examtype == 'SCHOLARSHIPTEST' ?'' :infobox?.testsCount}} {{infobox.infoboxName || infobox?.shortname}}
                    <!-- {{infobox.examtypeIntended == "TIMEBOUND" || infobox.paper.totaltests == 1 ? "": "s"}} -->
                    <i class="fa fa-caret-right" aria-hidden="true"></i>
                </span>
                <img [src]="infobox?.logo" class="info-tooltipicon"  *ngIf="infobox?.examtype == '53355d15-4a4a-4df8-a881-688c43f0c65e'"/>
                <span href={{infobox.link.route}} (click)="gotoList($event)" style="cursor: pointer;" *ngIf="infobox.paper.completedtests>0 && infobox?.examtype !== '53355d15-4a4a-4df8-a881-688c43f0c65e'">
                    {{infobox.examtype == 'SCHOLARSHIPTEST' ?'' :infobox?.paper?.testsCount}} {{infobox.infoboxName || infobox?.shortname}}
                    <!-- {{infobox.examtypeIntended == "TIMEBOUND" || infobox.paper.totaltests == 1 ? "": "s"}} -->
                    <i class="fa fa-caret-right" aria-hidden="true"></i>
                </span>
            </div>
            <div class="subcrb-box">
                <span class="freetxt"  *ngIf="infobox?.shortname == 'WIT'">Free</span>
                <!-- <span class="freetxt"  *ngIf="infobox.examtype == 'PREVIOUSYEAR' ||infobox.examtype ==  'CYOT,67521' || infobox.examtype == 'SCOREMOCKTEST'">Free</span> -->
                <!-- <span class="freetxt" *ngIf="infobox.examtype == 'SCHOLARSHIPTEST'">PAID</span> -->
                <!-- <span class="freetxt" *ngIf="freeExamcount[infobox.examtype] &&  (freeExamcount[infobox.examtype] -infobox?.paper?.completedtests  ) > 0 ||(freeExamcount[infobox.examtype] - infobox?.paper?.completedtests ) == 0" >{{freeExamcount[infobox.examtype] -infobox?.paper?.completedtests }} Free</span> -->
                <span class="freetxt box"  *ngIf="infobox?.shortname != 'WIT' && !infobox?.subscribeStatus">SUBSCRIBE</span>
            </div>
        </div>
    </div>
</ng-container>


<ng-container *ngIf="false">
    <ng-container *ngIf="(tenant!='infinitylearn' && isTimeBoundTestType) || infobox.examtype == 'GRANDTEST' || infobox.examtype == 'SCHOLARSHIPTEST'">
        <ng-container *ngIf="latestTimeboundTest && latestTimeboundTest.examtype == infobox.examtype;else notLatestTimeboundTest">
            <ng-container *ngIf="isCurrentTimeGreaterExamEndtime(latestTimeboundTest, null) || latestTimeboundTest['testtaken'];else latestTimeboundTestTimeNotOver"></ng-container>
            <ng-template #latestTimeboundTestTimeNotOver>
                <ng-container  *ngIf="!curTenantDetails['toRegisterBeforeAttempt']; else others">
                    <div class="UNFAPP-asmnt-upcmng-box">
                        <img src="assets/img/assessment/test-icon.svg" />
                        <div class="UNFAPP-asmnt-upcminfo">
                            <h3>{{(infobox.examname == 'JEEADVANCED' || infobox.examname == 'NTSE') ? latestTimeboundTest['schedulename']: latestTimeboundTest['rulename']}}</h3>
                            <h4>{{displayFormatedDateTime(latestTimeboundTest)}}</h4>
                            <button class="UNFAPP-asmnt-upcmn-link" (click)="attemptTestNowSCTB(latestTimeboundTest, infobox.examtype)">Attempt Now <i class="fa fa-caret-right" aria-hidden="true"></i></button>
                        </div>
                    </div>
                </ng-container>
                <ng-template #others>
                    <ng-container *ngIf="latestTimeboundTest.enrolled;else notEnrolled">
                        <div class="UNFAPP-asmnt-upcmng-box">
                            <img src="assets/img/assessment/test-icon.svg" />
                            <div class="UNFAPP-asmnt-upcminfo">
                                <h3>{{(infobox.examname == 'JEEADVANCED' || infobox.examname == 'NTSE') ? latestTimeboundTest['schedulename']: latestTimeboundTest['rulename']}}</h3>
                                <h4>{{displayFormatedDateTime(latestTimeboundTest)}}</h4>
                                <button class="UNFAPP-asmnt-upcmn-link" 
                                    *ngIf="latestTimeboundTest && availableForAttempt(latestTimeboundTest); else enrolledBtn"
                                    (click)="attemptTestNow(latestTimeboundTest, infobox.examtype)">{{latestTimeboundTest['resume'] && latestTimeboundTest['resume']===true ? 'Resume Now' : 'Attempt now'}}
                                    <i class="fa fa-caret-right" aria-hidden="true"></i>
                                </button>
                                <ng-template #enrolledBtn>
                                    <button class="UNFAPP-asmnt-upcmn-link" 
                                        (click)="comingSoon(latestTimeboundTest)">ENROLLED
                                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                                    </button>
                                </ng-template>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #notEnrolled>
                        <ng-container *ngIf="!canRegisterTimeChecking(latestTimeboundTest)">NO UPCOMING TEST AVAILABLE</ng-container>
                        <div class="UNFAPP-asmnt-upcmng-box" *ngIf="canRegisterTimeChecking(latestTimeboundTest)">
                            <img src="assets/img/assessment/test-icon.svg" />
                            <div class="UNFAPP-asmnt-upcminfo">
                                <h3>{{(infobox.examname == 'JEEADVANCED'  ||infobox.examname == 'NTSE' ) ? latestTimeboundTest['schedulename']: latestTimeboundTest['rulename']}}</h3>
                                <h4>{{displayFormatedDateTime(latestTimeboundTest)}}</h4>
                                <button class="UNFAPP-asmnt-upcmn-link" (click)="registerNow(latestTimeboundTest)">REGISTER NOW
                                    <i class="fa fa-caret-right" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    </ng-template>
                </ng-template>
            </ng-template>
        </ng-container>
        <ng-template #notLatestTimeboundTest>
            <ng-container *ngIf="checkUpcomingAvailble()"></ng-container>
          </ng-template>
    </ng-container>
</ng-container>
